export default function IconMenuDiagram () {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.75 0H0.25C0.111938 0 0 0.111938 0 0.25V19.75C0 19.8881 0.111938 20 0.25 20H19.75C19.8881 20 20 19.8881 20 19.75V0.25C20 0.111938 19.8881 0 19.75 0ZM19.5 9.69751H6.36987V5.29626H19.5V9.69751ZM5.86987 9.69751H0.5V5.29626H5.86987V9.69751ZM0.5 10.1975H5.86987V14.5988H0.5V10.1975ZM6.36987 10.1975H19.5V14.5988H6.36987V10.1975ZM19.5 4.79626H6.36987V0.5H19.5V4.79626ZM5.86987 0.5V4.79626H0.5V0.5H5.86987ZM0.5 15.0988H5.86987V19.5H0.5V15.0988ZM6.36987 19.5V15.0988H19.5V19.5H6.36987Z"
        fill="black"/>
    </svg>
  )
}
